module.exports = __webpack_public_path__ + "media/images/testimonial-mosquito-hunters-3ea1d9bc50ec6421e2c818db5f94b90d.png";